import { createVNode, createComponentVNode } from "inferno";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { Component } from 'inferno';

var DecisionRulesIndexCellComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(DecisionRulesIndexCellComponent, _Component);

  function DecisionRulesIndexCellComponent() {
    _classCallCheck(this, DecisionRulesIndexCellComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(DecisionRulesIndexCellComponent).apply(this, arguments));
  }

  _createClass(DecisionRulesIndexCellComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          row = _this$props.row,
          rowIndex = _this$props.rowIndex;
      var components = this.context.components;
      var innerComponents = components.getComponents('cell-inner', {
        cellType: 'rule-index',
        row: row,
        rowIndex: rowIndex
      });
      return createVNode(1, "td", "rule-index", [innerComponents && innerComponents.map(function (InnerComponent) {
        return createComponentVNode(2, InnerComponent, {
          "row": row,
          "rowIndex": rowIndex
        });
      }), rowIndex + 1], 0, {
        "data-row-id": row.id
      });
    }
  }]);

  return DecisionRulesIndexCellComponent;
}(Component);

export { DecisionRulesIndexCellComponent as default };
//# sourceMappingURL=DecisionRuleIndexCellComponent.js.map